module.exports = __webpack_public_path__ + "static/img/img(53).80809c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(53).png
// module id = f3ob
// module chunks = 1